import { defineAsyncComponent } from 'vue'

const VehicleType = defineAsyncComponent(() => import('./vehicle-type.vue'))
const VehicleTypeModal = defineAsyncComponent(() => import('./vehicle-type-modal.vue'))
const VehicleTypesModal = defineAsyncComponent(() => import('./vehicle-types-modal.vue'))
const VehicleTypesSelect = defineAsyncComponent(() => import('./vehicle-types-select.vue'))
const VehicleTypesTable = defineAsyncComponent(() => import('./vehicle-types-table.vue'))

export { VehicleType, VehicleTypeModal, VehicleTypesModal, VehicleTypesSelect, VehicleTypesTable }
